import React, { useState, useRef } from "react";
import { FileUpload } from "primereact/fileupload";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import { Message } from "primereact/message";
import Papa, { parse } from "papaparse";
import Layout from "../../Layout";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

const ImportListaEnderecosColeta = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const fileUploadRef = useRef(null);
  const [fileName, setFileName] = useState("");

  const  [enderecamento, setEnderecamento] = useState({
    listaEnderecos : [],
    faixasEnderecos : [], 
    multiCast : []
  });

  React.useEffect(()=>{
    console.log(enderecamento)
  },[enderecamento])
  const handleFileUpload = (event) => {
    //setLoading(true);
    setError("");
    const file = event.files[0];
    
    if (file) {
      const reader = new FileReader();
      reader.onload = ({ target }) => {
        //console.log(target)
        
        const temp = processarIPs(target.result)
        const temp2 = classificarEnderecamento(temp)
       // console.log(temp) 
      };
      reader.readAsText(file);
      handleClear()
    }
  };

  const handleClear = () => {
    setData([]);
    setLoading(false);
    setError("");
    if (fileUploadRef.current) {
      fileUploadRef.current.clear();
    }
  };

  const processarIPs = (listaIPs) => {
    // 1. Remove espaços, quebra linhas, e transforma em array único
    let ips = listaIPs
        .split(/[\s,]+/)
        .filter(ip => ip.trim() !== '');
   
    // 2. Remove duplicados
    ips = Array.from(new Set(ips));

    // 3. Ordena os IPs numericamente
    ips.sort((a, b) => {
        const toNum = ip => ip.split('.').reduce((acc, oct) => acc * 256 + +oct, 0);
        return toNum(a) - toNum(b);
    });

    // 4. Agrupa IPs sequenciais
    const resultado = [];
    let inicio = ips[0];
    let anterior = inicio;

    const ipToNumber = ip => ip.split('.').reduce((acc, oct) => acc * 256 + +oct, 0);
    const numberToIp = num => [24, 16, 8, 0].map(shift => (num >> shift) & 255).join('.');

    for (let i = 1; i <= ips.length; i++) {
        if (i < ips.length && ipToNumber(ips[i]) === ipToNumber(anterior) + 1) {
            anterior = ips[i];
        } else {
            if (inicio === anterior) {
                resultado.push(inicio);
            } else {
                resultado.push(`${inicio}-${anterior}`);
            }
            inicio = ips[i];
            anterior = inicio;
        }
    }

    return resultado;
}

function classificarEnderecamento(lista) {
 const listaEnderecos = [];
  const faixasEnderecos = [];
  const multiCast = [];

  lista.forEach(item => {

    
    const entrada = item.trim();

    if (entrada.endsWith('.*')) {
      multiCast.push(entrada);
    } else if (entrada.includes('-') && isValidIpRange(entrada)) {
      faixasEnderecos.push(entrada);
    } else {
      listaEnderecos.push(entrada);
    }
  });

  if(listaEnderecos || multiCast || faixasEnderecos){
    

    confirmDialog({
          message: 'Deseja processar o arquivo e incluir os endereços válidos nas listas de coletas?',
          header: 'Confirmação',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Sim',
          rejectLabel: 'Não',
          accept: () => {
              props.setEnderecosColeta(listaEnderecos);
              props.setMultiCasts(multiCast);
              props.setFaixasEndereco(faixasEnderecos);
          } 
      });
  }

}


function isValidIpRange(range) {
    const regex = /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)-((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/;
    if (!regex.test(range)) return false;

    const [startIp, endIp] = range.split('-');

    const ipToNumber = ip => ip.split('.').reduce((acc, octet) => acc * 256 + Number(octet), 0);

    return ipToNumber(endIp) >= ipToNumber(startIp);
}


  return (

    <div className="p-4">
      <span><strong>{fileName ? 'Arquivo Selecionado : '+ fileName :  "Importar Lista Endereços"}</strong> </span>
      <p style={{marginTop : '20px'}}>* O arquivo deve conter informações de :</p>
      <ul style={{fontSize: '10px'}}>
        <li>Redes: Endereços de rede unicast (192.168.0.* ou 10.0.0.*, etc).</li>
        <li>Intervalos: Endereço inicial e final (192.168.0.10-192.168.0.27 ou 10.0.0.13-10.0.0.127 ou 192.168.89.10-192.168.89.254 etc)</li>
        <li>Ips/Hostname: Endereços Unicast/Hostname (192.168.0.10 ou 10.0.0.13 ou impressoramkt ou vendaspb1)</li>
      </ul>
      <p style={{marginTop : '10px', fontSize : '10px'}}>** Endereços de mesma rede (ex: 192.168.0.10, 192.168.0.11, 192.168.0.13) serão agrupados e adicionados como um intervalo de rede.</p>
      <Card className="shadow-none">
        <FileUpload
            ref={fileUploadRef}
            mode="basic"
            accept=".txt"
            auto
            customUpload
            uploadHandler={handleFileUpload}
            onSelect={(e)=>{
                setFileName(e.files[0].name)                
            }}
            chooseLabel="Selecionar Arquivo (.txt)"
          />
      </Card>


      {error && !loading && (
        <div className="mt-4">
          <Message severity="error" text={error} />
        </div>
      )}

      

      <div className="mt-4 flex gap-4">
       
        {data.length !== 0 ? <button disabled={loading} className="p-button p-button-primary" onClick={()=>{
            confirmDialog({
                            message: 'Confirma a importação dos registros agora?',
                            header: 'Confirmação',
                            icon: 'pi pi-exclamation-triangle',
                            acceptLabel: 'Sim',
                            rejectLabel: 'Não',
                            accept: () => {
                                //insertEmpresa(empresa)
                            } 
                        });
        }}>Importar Dados</button> : null }
      </div>
    </div>

  );
};

export default ImportListaEnderecosColeta;
